import { UserProvider } from '~/modules/auth/components';
import { Experiments } from '~/modules/experiments/Experiments';
import { Analytics } from '~/modules/monitoring/analytics/Analytics';

import { WmgSessionProvider } from './modules/auth/contexts';
import { Router } from './router';

export function ProtectedApp() {
  return (
    <WmgSessionProvider>
      <UserProvider>
        <Analytics />
        <Experiments />
        <Router />
      </UserProvider>
    </WmgSessionProvider>
  );
}

ProtectedApp.displayName = 'ProtectedApp';
